const value = Object.freeze({
  Information: 0,
  History: 1,
  Custodian: 2,
  Binnacle: 3,
});
export default value;
